import React from 'react';

import SpriteIcon from 'web/components/common/icon/SpriteIcon';

import classNames from 'classnames/bind';
import styles from './Logo.scss';
import PolicyContent from 'web/routes/info/PolicyContent';
const cx = classNames.bind(styles);

const Logo = React.memo(({ title }) => {
  return (
    <div className={cx('Logo')}>
      <div className="logo-box">
        <SpriteIcon name={`img-login-sb`} />
        <div className="title">{title}</div>
        <div style={{ marginTop: '10px', overflowY: 'scroll' }}>
          {title === '개인정보 취급방침' && <PolicyContent policy={'policy'} />}
        </div>
      </div>
    </div>
  );
});

export default Logo;
